import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18c6a0c3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-header" }
const _hoisted_2 = { class: "card-left" }
const _hoisted_3 = { class: "list-group" }
const _hoisted_4 = { class: "detail-row" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_image_camera_component = _resolveComponent("image-camera-component")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_station_images_modal_component = _resolveComponent("station-images-modal-component")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, { class: "box-card" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, {
          class: "box-card-row",
          gutter: 3
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { lg: 15 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("label.dataEnvironment")), 1),
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.date), 1)
                    ])
                  ]),
                  _createVNode(_component_el_table, {
                    data: _ctx.dataTable,
                    "show-header": false,
                    "row-class-name": _ctx.tableRowClassName,
                    style: {"width":"100%"},
                    stripe: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        class: "bold",
                        label: "Date"
                      }, {
                        default: _withCtx((scope) => [
                          (scope.row.code == 'gps' || scope.row.code == 'angle')
                            ? (_openBlock(), _createElementBlock("strong", {
                                key: 0,
                                class: _normalizeClass(scope.row.code === 'gps' || scope.row.code === 'angle' ? '' : 'pointer'),
                                onClick: ($event: any) => (_ctx.onParameterClick(scope.row.code, scope.row.measurement))
                              }, _toDisplayString(scope.row.magnitude), 11, _hoisted_5))
                            : (_openBlock(), _createElementBlock("strong", {
                                key: 1,
                                class: _normalizeClass(scope.row.code === 'gps' || scope.row.code === 'angle' ? '' : 'pointer'),
                                onClick: ($event: any) => (_ctx.onParameterClick(scope.row.code))
                              }, _toDisplayString(scope.row.magnitude), 11, _hoisted_6))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "measurement",
                        align: "right",
                        label: _ctx.$t('label.unit')
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["data", "row-class-name"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              class: "image-col",
              lg: 9
            }, {
              default: _withCtx(() => [
                _createVNode(_component_image_camera_component, { lastImage: _ctx.lastImage }, null, 8, ["lastImage"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.isModalImageVisible)
      ? (_openBlock(), _createBlock(_component_station_images_modal_component, {
          key: 0,
          title: _ctx.$t('label.imageViewer'),
          stationId: _ctx.station,
          onClose: _ctx.closeModalImage
        }, null, 8, ["title", "stationId", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}